import { useState } from "react";
import { userObject, changePassword } from "../../network/lib/user.js";
import { removeAuth } from "../utils/auth.js";
import { useNavigate } from "react-router-dom";
import { showHideLoader } from "../utils/helper.js";

function ChangePassword({ user }) {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const setToDefault = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
  };

  const handleCancel = (e) => {
    e.preventDefault();

    let message = document.getElementById("message");
    message.innerHTML = "";

    setToDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let message = document.getElementById("message");
    message.innerHTML = "";

    if (!oldPassword) {
      message.innerHTML = "Please enter Old Password";
    } else if (!newPassword) {
      message.innerHTML = "Please enter New Password";
    } else if (!confirmNewPassword) {
      message.innerHTML = "Please enter Confirm New Password";
    } else if (newPassword != confirmNewPassword) {
      message.innerHTML =
        "New Password and Confirm New Password are not matching";
    } else {
      showHideLoader(true);

      userObject.userName = user.userName;
      userObject.oldPassword = oldPassword;
      userObject.password = newPassword;
      userObject.roleId = user.roleId;
      userObject.activityDoneBy = user.userName;

      changePassword(userObject).then((res) => {
        if (res.status == 200 && res.data) {
          message.classList.replace("alert", "success");
          message.innerHTML = "Password Changed successfully!!!";

          removeAuth();
          navigate("/admin/login");
        } else {
          message.innerHTML =
            "Either Old Password is wrong or Some error occurred. Please try again";
        }
        setToDefault();
      });
    }
  };

  const contents = (
    <>
      <table style={{ width: "48%" }}>
        <tbody>
          <tr>
            <th align="center" colSpan="2">
              Change Password
            </th>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Old Password</span>
            </td>
            <td>
              <input
                name="oldPassword"
                type="password"
                value={oldPassword}
                id="oldPassword"
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">New Password</span>
            </td>
            <td>
              <input
                name="newPassword"
                type="password"
                value={newPassword}
                id="newPassword"
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Confirm New Password</span>
            </td>
            <td>
              <input
                name="confirmNewPassword"
                type="password"
                value={confirmNewPassword}
                id="confirmNewPassword"
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td style={{ textAlign: "right", paddingRight: "49px" }}>
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );

  return contents;
}

export default ChangePassword;
